module.exports = __webpack_public_path__ + "img/benevento.5918bd88.png";